export const BUILD_INFO = { 
  buildNumber: '1763407496707', 
  buildDate: '2025-11-17 19:24:56 UTC',
  gitBranch: 'oyvindh/To-Antd',
  gitCommitHash: '2a660fe'
};
